"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var injectBobMicroservice_1 = require("./functions/injectBobMicroservice");
exports.injectBobMicroservice = injectBobMicroservice_1.default;
var injectScriptToElement_1 = require("./functions/injectScriptToElement");
var injectStyleSheetToElement_1 = require("./functions/injectStyleSheetToElement");
exports.injectScriptToBody = function (src) {
    return injectScriptToElement_1.default(src, document.body);
};
exports.injectStyleSheetToHead = function (src) {
    return injectStyleSheetToElement_1.default(src, document.head || document.body);
};
